import { render, staticRenderFns } from "./UserRowMobile.vue?vue&type=template&id=034ff325&scoped=true&"
import script from "./UserRowMobile.vue?vue&type=script&lang=ts&"
export * from "./UserRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./UserRowMobile.vue?vue&type=style&index=0&id=034ff325&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ff325",
  null
  
)

export default component.exports